import React, { useEffect, useState } from 'react';
import syncService from '../../services/syncService';
import './LockoutScreen.css';

function LockoutScreen() {
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState('');

  async function handleSync() {
    if (!navigator.onLine) {
      setError('Please connect to internet to continue');
      return;
    }

    setSyncing(true);
    setError('');

    const result = await syncService.fullSync();

    if (result.success) {
      window.location.href = '/dashboard';
    } else {
      setError(result.message || 'Sync failed');
    }

    setSyncing(false);
  }

  return (
    <div className="lockout-screen">
      <div className="lockout-box">
        <div className="lockout-icon">🔒</div>
        <h1>Subscription Verification Required</h1>
        <p>Please connect to internet to verify your subscription status.</p>

        {!navigator.onLine && (
          <div className="error-message">
            ⚠️ No internet connection detected
          </div>
        )}

        {error && (
          <div className="error-message">
            ⚠️ {error}
          </div>
        )}

        <button 
          onClick={handleSync}
          disabled={syncing || !navigator.onLine}
          className="btn-verify"
        >
          {syncing ? 'Verifying...' : 'Verify Subscription'}
        </button>

        <p className="help-text">
          Need help? Contact support
        </p>
      </div>
    </div>
  );
}

export default LockoutScreen;